var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flat-pickr',{staticClass:"form-control",attrs:{"config":_vm.dateTimePicker,"placeholder":"Date and Time"},on:{"on-change":_vm.updated,"on-close":_vm.updated},model:{value:(_vm.datetime),callback:function ($$v) {_vm.datetime=$$v},expression:"datetime"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }